import { render, staticRenderFns } from "./CardCreator.vue?vue&type=template&id=1388bdee&scoped=true&"
import script from "./CardCreator.vue?vue&type=script&lang=js&"
export * from "./CardCreator.vue?vue&type=script&lang=js&"
import style0 from "./CardCreator.vue?vue&type=style&index=0&id=1388bdee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1388bdee",
  null
  
)

export default component.exports